<template>
  <sl-upload-file :title="fileId ? '重传' : '上传'" :extra-field="extra" :action="action"></sl-upload-file>
</template>
<script>
  export default {
    name:'uploadAnnex',
    data:{
      action:'',
      extra:{

      }
    },

    props:{
      orderId:{
        type:Number
      },
      fileType:{
        type:Number
      },
      fileId:{
        type:Number
      }
    },
    watch:{
      orderId(nv){
        if(nv){
          this.extra.orderId = nv
        }
      },
      fileType(nv){
        if(nv){
          this.extra.fileType = nv
        }
      },
      fileId(nv){
        if(nv){
          this.extra.fileId = nv
        }
      }
    },

    created(){
      this.action = this.$request.orderAnnexUploadUrl()
      this.extra = {
        orderId:this.orderId,
        fileType:this.fileType,
      }
      if(this.fileId){
        this.fileId = this.fileId
      }
    }
  }
</script>